import React from 'react'
import { BASE_FLAG_URL, PLACEHOLDER_URL } from './constants'

import styles from './index.module.css'

interface FlagProps {
  countryCode: string
}

export default function Flag({ countryCode }: FlagProps) {
  return (
    <img
      className={styles.flag}
      src={`${BASE_FLAG_URL}${countryCode}.svg`}
      alt={countryCode}
      aria-label={countryCode}
      onError={e => {
        const target = e.target as HTMLImageElement
        target.onerror = null
        target.src = PLACEHOLDER_URL
        target.alt = 'Flag not available'
        target.setAttribute('aria-label', 'Flag not available')
      }}
    />
  )
}
